/*
一张地图里的「势力 / 国家」。

历史上只有经典 7 国；为了让变体地图（例如世界地图里的 Britain / Holland）
也能渲染，这里扩展为「经典 7 国 + 常见的欧洲/世界变体势力」。

扩展国家只需两步：
  1. 在下面枚举里加成员，并在 countryAbbr 里加 3 字母缩写；
  2. 在 beta-src/src/webDiplomacyTheme.ts 的 countryPalette 里加配色
     （新成员用 withLight(main) 自动生成浅色即可）。
注：地图配置里的 countries 顺序决定后端 countryID（索引+1），
    与前端枚举顺序无关。
*/
enum Country {
  // ---- 经典 7 国 ----
  FRANCE = "France",
  AUSTRIA = "Austria",
  ENGLAND = "England",
  GERMANY = "Germany",
  RUSSIA = "Russia",
  ITALY = "Italy",
  TURKEY = "Turkey",
  // ---- 扩展：变体地图常见势力 ----
  BRITAIN = "Britain",
  HOLLAND = "Holland",
  BELGIUM = "Belgium",
  SPAIN = "Spain",
  PORTUGAL = "Portugal",
  SWEDEN = "Sweden",
  NORWAY = "Norway",
  DENMARK = "Denmark",
  POLAND = "Poland",
  CHINA = "China",
  JAPAN = "Japan",
  // ---- 美洲战火（1840）势力 ----
  ARGENTINA = "Argentina",
  BRAZIL = "Brazil",
  CHILE = "Chile",
  UNITED_KINGDOM = "United Kingdom",
  MEXICO = "Mexico",
  NEW_GRANADA = "New Granada",
  PERU = "Peru",
  UNITED_STATES = "United States",
  VENEZUELA = "Venezuela",
}

/** 国家名 -> 3 字母缩写（单一事实来源，abbrMap 由它派生） */
export const countryAbbr: { [key: string]: string } = {
  Russia: "RUS",
  Germany: "GER",
  Italy: "ITA",
  Austria: "AUS",
  England: "ENG",
  France: "FRA",
  Turkey: "TUR",
  Britain: "GBR",
  Holland: "HOL",
  Belgium: "BEL",
  Spain: "SPA",
  Portugal: "POR",
  Sweden: "SWE",
  Norway: "NOR",
  Denmark: "DEN",
  Poland: "POL",
  China: "CHN",
  Japan: "JPN",
  Argentina: "ARG",
  Brazil: "BRA",
  Chile: "CHI",
  "United Kingdom": "GBR",
  Mexico: "MEX",
  "New Granada": "NEW",
  Peru: "PER",
  "United States": "USA",
  Venezuela: "VEN",
};

/** 兼容原有导出名 */
export const abbrMap = countryAbbr;

export default Country;
